import { render } from "./CreateEventModal.vue?vue&type=template&id=5366e9d0&scoped=true"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"

import "./CreateEventModal.vue?vue&type=style&index=0&id=5366e9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5366e9d0"]])

export default __exports__